(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/triss-subscription/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/triss-subscription/assets/javascripts/init.js');
"use strict";


const baseUrl = svs.core.data.baseUrl;
const {
  PlayerRouter
} = svs.app.ReactRouter;
const Route = svs.app.ReactRouter.Route;
const Form = svs.ticketSubscription.Form;
const {
  Widget
} = svs.trissSubscription;
const Router = React.createElement(PlayerRouter, {
  basename: baseUrl,
  withRouter: true
}, React.createElement(Route, {
  component: _ref => {
    let {
      history
    } = _ref;
    return React.createElement(React.Fragment, null, React.createElement(Widget, {
      name: "topWidget"
    }), React.createElement("div", {
      className: "main-content-subscription"
    }, React.createElement("div", {
      className: "f-content margin-2"
    }, React.createElement(Form, {
      numberOfTickets: svs.utils.paramHandler.get({
        key: 'antal'
      }).value,
      onComplete: () => history.push('/tack')
    }))));
  },
  exact: true,
  path: "/"
}), React.createElement(Route, {
  exact: true,
  path: "/tack"
}, React.createElement(Widget, {
  name: "afterBuyWidget"
})));
const container = document.getElementById('reactContainer');
container && ReactDOM.render(Router, document.getElementById('reactContainer'));
setGlobal('svs.trissSubscription.Router', Router);

 })(window);